import { createFileRoute } from "@tanstack/react-router";

import { PageContainer } from "@/components/ui/page-container";
import { PageHeader } from "@/components/ui/page-header";

import { CadastroForm } from "./-components/cadastro-form";

export const Route = createFileRoute("/_app/cadastro/")({
	component: CadastroNewPage,
});

function CadastroNewPage() {
	return (
		<PageContainer>
			<PageHeader title="Novo cadastro" />

			<CadastroForm />
		</PageContainer>
	);
}
